import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { salesReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const salesReportRouteMetadata: IRouteMetadataObj<typeof salesReportRoutesObj> =
  {
    list: {
      title: "reportManagement.index.title",
      description: "empty",
      lazy: () => import("@pages/reportManagement/salesReport/table/page"),
      mode: "index",
      type: "main",
      icon: "FileChartLine",
      breadcrumbs: [],
      permission,
    },
  };

export const salesReportRoutes = createRoute<typeof salesReportRoutesObj>(
  salesReportRoutesObj,
  salesReportRouteMetadata,
);
